import { atomWithStorage } from 'utils/atomWithStorage';
import { useAtomValue, useSetAtom } from 'jotai';

const defaultSequenceCycle = atomWithStorage<string>(
  'sequenceDefaultCycle',
  'Cycle 2',
);

export function useDefaultSequenceCycle() {
  return useAtomValue(defaultSequenceCycle);
}

export function useSetDefaultSequenceCycle() {
  return useSetAtom(defaultSequenceCycle);
}
